/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { PidxBannerService } from './pidx-banner.service'
import { PidxNotificationsComponent } from './pidx-notifications.component'

@NgModule({
  imports: [CommonModule, RouterModule, PorscheDesignSystemModule],
  declarations: [PidxNotificationsComponent],
  providers: [PidxBannerService],
  exports: [PidxNotificationsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PidxNotificationsModule {}
